import React, { useState } from "react";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setStatus("");
        setError("");

        try {
            const res = await fetch("/api/auth/request-password-reset", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.message || "Failed to request password reset.");
                setSubmitting(false);
                return;
            }

            setStatus(
                data.message ||
                "If an account with that email exists, a reset link has been created."
            );
            setEmail("");
        } catch (err) {
            console.error("Forgot password error:", err);
            setError("Server error.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                background: "var(--background, #f7f7fb)",
                padding: 24,
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: 460,
                    background: "var(--card-bg, #fff)",
                    border: "1px solid var(--border, #e5e7eb)",
                    borderRadius: 20,
                    padding: 28,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                }}
            >
                <h1 style={{ margin: "0 0 10px", fontSize: "1.6rem" }}>
                    Forgot Password
                </h1>

                <p style={{ margin: "0 0 20px", color: "var(--muted, #666)" }}>
                    Enter your email and we’ll send a reset link if the account exists.
                </p>

                <form onSubmit={handleSubmit} style={{ display: "grid", gap: 14 }}>
                    <label style={{ display: "grid", gap: 8 }}>
                        <span>Email</span>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            style={{
                                padding: "12px 14px",
                                borderRadius: 12,
                                border: "1px solid var(--border, #d1d5db)",
                                outline: "none",
                            }}
                        />
                    </label>

                    <button
                        type="submit"
                        disabled={submitting}
                        style={{
                            padding: "12px 16px",
                            borderRadius: 12,
                            border: "none",
                            cursor: submitting ? "not-allowed" : "pointer",
                            background: "var(--accent-color, #5A3EBA)",
                            color: "#fff",
                            fontWeight: 700,
                            opacity: submitting ? 0.7 : 1,
                        }}
                    >
                        {submitting ? "Sending..." : "Send Reset Link"}
                    </button>
                </form>

                {status ? (
                    <p style={{ marginTop: 16, color: "green" }}>{status}</p>
                ) : null}

                {error ? (
                    <p style={{ marginTop: 16, color: "crimson" }}>{error}</p>
                ) : null}

                <div style={{ marginTop: 20 }}>
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;